var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFillBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_16298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20C40.5 25.3043 38.3929 30.3914 34.6421 34.1421C30.8914 37.8929 25.8043 40 20.5 40C15.1957 40 10.1086 37.8929 6.35786 34.1421C2.60714 30.3914 0.5 25.3043 0.5 20C0.5 14.6957 2.60714 9.60859 6.35786 5.85786C10.1086 2.10714 15.1957 0 20.5 0C25.8043 0 30.8914 2.10714 34.6421 5.85786C38.3929 9.60859 40.5 14.6957 40.5 20ZM30.575 12.425C30.3964 12.247 30.1838 12.1069 29.9498 12.013C29.7159 11.9191 29.4654 11.8734 29.2133 11.8785C28.9613 11.8837 28.7128 11.9396 28.4829 12.0429C28.2529 12.1463 28.0462 12.2949 27.875 12.48L19.1925 23.5425L13.96 18.3075C13.6046 17.9763 13.1344 17.796 12.6487 17.8046C12.1629 17.8131 11.6995 18.0099 11.3559 18.3534C11.0124 18.697 10.8156 19.1604 10.8071 19.6462C10.7985 20.1319 10.9788 20.6021 11.31 20.9575L17.925 27.575C18.1032 27.7529 18.3154 27.893 18.549 27.9871C18.7825 28.0812 19.0326 28.1273 19.2844 28.1226C19.5361 28.118 19.7843 28.0627 20.0142 27.96C20.2441 27.8573 20.451 27.7094 20.6225 27.525L30.6025 15.05C30.9427 14.6962 31.1307 14.2232 31.126 13.7324C31.1213 13.2416 30.9244 12.7722 30.5775 12.425H30.575Z",
    fill: "#1F8DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_16298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFillBig);
export default __webpack_public_path__ + "static/media/check-circle-fill-big.da9e78755c14840f6d87c95758bde976.svg";
export { ForwardRef as ReactComponent };